import { style } from '@do/walrus';
import marketplaceBg from './assets/backgrounds/Registration_Marketplace.jpg';
import oauthBg from './assets/backgrounds/Registration_Oauth.gif';
import teamBg from './assets/backgrounds/Registration_Team.gif';
import background from './assets/backgrounds/background.png';
import vars from './assets/overwrite-vars.scss';
import ghStudentBg from './assets/partners/github/github_student_bg.png';
import ghStudentLogo from './assets/partners/github/github_student_logo.png';
import glitchBg from './assets/partners/glitch/glitch_bg.png';
import glitchLogo from './assets/partners/glitch/glitch_logo.png';
import lfBg from './assets/partners/lf/lf_bg.png';
import lfLogo from './assets/partners/lf/lf_logo.png';

import { GROWTH_ENG_GHSP_OFFER_UPGRADE } from './constants';
import { ButtonVariations, VariantMap } from './interfaces/variant';

const defaultVariant = {
  type: 'defaultVariant',
  background: {
    image: background
  },
  title: 'Create your account',
  subtitle:
    'Start spending more time on your projects and less time managing your infrastructure.',
  footerTextColor: vars.grey_darkest,
  footerLinkColor: vars.primary
};

const registrationVariants: VariantMap = {
  primary: defaultVariant,

  marketplace: Object.assign({}, defaultVariant, {
    type: 'marketplace',
    background: {
      image: marketplaceBg,
      horizontalPosition: 'right'
    },
    title: 'Sign up & deploy – in minutes!',
    subtitle: 'Marketplace solutions let you deploy with a single click!',
    metadata: {
      title:
        'Your {{registrationFormData.marketplace_app.name}} app is a few steps away',
      description: 'You need to create an account on DigitalOcean'
    }
  }),

  community: Object.assign({}, defaultVariant, {
    type: 'community',
    subtitle:
      'Start learning and growing with DigitalOcean’s community. Creating an account will make it easier to engage with our thousands of free tutorials and other developers in our community. As a bonus, your new account will also give you access to DigitalOcean’s cloud offerings.'
  }),

  oauth_app: Object.assign({}, defaultVariant, {
    type: 'oauth',
    background: {
      image: oauthBg
    },
    title: 'Authorization needed',
    subtitle:
      'In order to use {{registrationFormData.oauth_app.name}}, you’ll need to create a DigitalOcean account.'
  }),

  team: Object.assign({}, defaultVariant, {
    type: 'team',
    background: {
      image: teamBg,
      horizontalPosition: 'center',
      verticalPosition: 'center'
    },
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{registrationFormData.team}} has invited you to join them. Sign up and start making waves with your team today!'
  }),

  glitchPartner: Object.assign({}, defaultVariant, {
    splash: {
      type: 'glitchPartner',
      background: {
        image: glitchBg
      },
      logo: {
        image: glitchLogo
      },
      title: {
        text: 'Deploy your project to DigitalOcean'
      },
      subtitle: {
        text: 'Easily deploy Glitch projects on DigitalOcean’s App Platform using your project’s environment variable configuration.'
      }
      /*button: {
        variation: ButtonVariations.PRIMARY,
        text: 'Learn more',
        url:
          'https://www.digitalocean.com/blog/new-droplet-console-ssh-support/'
      }*/
    }
  }),

  lfPartner: Object.assign({}, defaultVariant, {
    splash: {
      type: 'lfPartner',
      background: {
        image: lfBg
      },
      logo: {
        image: lfLogo
      },
      title: {
        text: 'Open Source Skills Development'
      },
      subtitle: {
        text: "Linux Foundation Training & Certification offers training courses to build knowledge and skills, and certification exams to test and demonstrate learnings and capabilities, around the world's most important open source technologies, including Linux, Kubernetes, Node.js, Hyperledger, RISC-V, and much more."
      },
      textColor: style.colors.grey.darkest
    }
  }),
  githubStudentPack: Object.assign({}, defaultVariant, {
    type: 'githubStudentPack',
    title: 'Sign up for DigitalOcean',
    splash: {
      type: 'ghPartner',
      background: {
        image: ghStudentBg
      },
      logo: {
        image: ghStudentLogo
      },
      title: {
        text: 'GitHub Student Developer Pack'
      },
      subtitle: {
        text: `As a part of GitHub student developer pack, you will receive ${
          GROWTH_ENG_GHSP_OFFER_UPGRADE
            ? '$200' /* eslint-disable-line @do/no-hardcoded-prices */
            : '$100' /* eslint-disable-line @do/no-hardcoded-prices */
        } in credit that are valid for 1 year. Once you sign up you will be prompted to verify your GitHub account`
      },
      textColor: style.colors.grey.darkest,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Learn more',
        fullWidth: true,
        url: 'https://education.github.com/pack?utm_source=github+digitalocean'
      }
    },
    background: {
      color: '#eff2fb'
    },
    subtitle:
      'You will need to create an account by authenticating your GitHub account to claim your credits'
  })
};

export default registrationVariants;

export const RefcodeVariantMapping: VariantMap = {
  marketrefcode: registrationVariants.marketplace,
  '58a925265b7b': registrationVariants.glitchPartner,
  '3b1eb93990e5': registrationVariants.lfPartner,
  community: registrationVariants.community
};
